const schema = {
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "http://example.com/root.json",
  "type": "object",
  "title": "The Root Schema",
  "required": [
    "module_id",
    "json"
  ],
  "properties": {
    "module_id": {
      "$id": "#/properties/module_id",
      "type": "integer",
      "title": "The Module_id Schema",
      "default": 0,
      "examples": [
        1
      ]
    },
    "json": {
      "$id": "#/properties/json",
      "type": "object",
      "title": "The Json Schema",
      "required": [
        "module_id",
        "title",
        "publish_date",
        "image_url",
        "description",
        "topic_meta_ids",
        "language_id",
        "type",
        "content_level",
        "time_length",
        "last_update",
        "translations",
        "ratings"
      ],
      "properties": {
        "module_id": {
          "$id": "#/properties/json/properties/module_id",
          "type": "integer",
          "title": "The Module_id Schema",
          "default": 0,
          "examples": [
            1
          ]
        },
        "title": {
          "$id": "#/properties/json/properties/title",
          "type": "string",
          "title": "The Title Schema",
          "default": "",
          "examples": [
            "Ten Common NWP Misconceptions"
          ],
         
        },
        "publish_date": {
          "$id": "#/properties/json/properties/publish_date",
          "type": [ "string", "null" ],
          "title": "The Publish_date Schema",
          "default": "",
          "examples": [
            "2002-05-02"
          ]
         
        },
        "image_url": {
          "$id": "#/properties/json/properties/image_url",
          "type": [ "string", "null" ],
          "title": "The Image_url Schema",
          "default": "",
          "examples": [
            "tencom_thumb.jpg"
          ]
         
        },
        "description": {
          "$id": "#/properties/json/properties/description",
          "type": "string",
          "title": "The Description Schema",
          "default": "",
          "examples": [
            "This lesson introduces forecasters to ten of the most commonly encountered or significant misconceptions about NWP models. This list of ten misconceptions includes issues surrounding data assimilation, model resolution, physical parameterizations, and post-processing of model forecast output."
          ]
         
        },
        "topic_meta_ids": {
          "$id": "#/properties/json/properties/topic_meta_ids",
          "type": "array",
          "title": "The Topic_meta_ids Schema",
          "items": {
            "$id": "#/properties/json/properties/topic_meta_ids/items",
            "type": "integer",
            "title": "The Items Schema",
            "default": 0,
            "examples": [
              15
            ]
          }
        },
        "language_id": {
          "$id": "#/properties/json/properties/language_id",
          "type": [ "integer", "null" ],
          "title": "The Language_id Schema",
          "default": 0,
          "examples": [
            1
          ]
        },
        "type": {
          "$id": "#/properties/json/properties/type",
          "type": [ "integer", "null" ],
          "title": "The Type Schema",
          "default": 0,
          "examples": [
            1
          ]
        },
        "content_level": {
          "$id": "#/properties/json/properties/content_level",
          "type": [ "integer", "null" ],
          "title": "The Content_level Schema",
          "default": 0,
          "examples": [
            2
          ]
        },
        "time_length": {
          "$id": "#/properties/json/properties/time_length",
          "type": ["string", "null" ],
          "title": "The Time_length Schema",
          "default": "",
          "examples": [
            "1.25 - 1.50"
          ]
         
        },
        "last_update": {
          "$id": "#/properties/json/properties/last_update",
          "type": "string",
          "title": "The Last_update Schema",
          "default": "",
          "examples": [
            "0000-00-00"
          ]
         
        },
        "translations": {
          "$id": "#/properties/json/properties/translations",
          "type": "array",
          "title": "The Translations Schema",
          "items": {
            "$id": "#/properties/json/properties/translations/items",
            "type": "object",
            "title": "The Items Schema",
            "required": [
              "module_id",
              "language_id"
            ],
            "properties": {
              "module_id": {
                "$id": "#/properties/json/properties/translations/items/properties/module_id",
                "type": "integer",
                "title": "The Module_id Schema",
                "default": 0,
                "examples": [
                  1
                ]
              },
              "language_id": {
                "$id": "#/properties/json/properties/translations/items/properties/language_id",
                "type": "integer",
                "title": "The Language_id Schema",
                "default": 0,
                "examples": [
                  1
                ]
              }
            }
          }
        },
        "ratings": {
          "$id": "#/properties/json/properties/ratings",
          "type": "object",
          "title": "The Ratings Schema",
          "required": [
            "stars",
            "reviews"
          ],
          "properties": {
            "stars": {
              "$id": "#/properties/json/properties/ratings/properties/stars",
              "type": "integer",
              "title": "The Stars Schema",
              "default": 0,
              "examples": [
                0
              ]
            },
            "reviews": {
              "$id": "#/properties/json/properties/ratings/properties/reviews",
              "type": "integer",
              "title": "The Reviews Schema",
              "default": 0,
              "examples": [
                0
              ]
            }
          }
        }
      }
    }
  }
}


  export default schema;